import { findIndexById } from 'components/common/virtualizedList/model';
import { InspectionVirtualRow } from 'shared/domain/checklistTree';

export const INSPECTION_ITEM_VIRTUALIZATION_OVERSCAN = 7;
/** The flattened protocol list is always windowed. */
export const VIRTUALIZE_CHECKLIST_ITEM_MIN_COUNT = 1;
export const COLLAPSED_CHECKLIST_ITEM_HEIGHT_PX = 57;
export const EXPANDED_CHECKLIST_ITEM_ESTIMATED_HEIGHT_PX = 320;
export const SECTION_HEADER_ESTIMATED_HEIGHT_PX = 56;
export const SECTION_CONTENT_ESTIMATED_HEIGHT_PX = 140;

export function estimateChecklistItemHeight(isExpanded: boolean): number {
  return isExpanded
    ? EXPANDED_CHECKLIST_ITEM_ESTIMATED_HEIGHT_PX
    : COLLAPSED_CHECKLIST_ITEM_HEIGHT_PX;
}

export function estimateInspectionVirtualRowHeight(
  row: InspectionVirtualRow,
  isItemExpanded: boolean
): number {
  if (row.type === 'sectionHeader') {
    return SECTION_HEADER_ESTIMATED_HEIGHT_PX;
  }
  if (row.type === 'sectionContent') {
    return SECTION_CONTENT_ESTIMATED_HEIGHT_PX;
  }
  return estimateChecklistItemHeight(isItemExpanded);
}

function resolveInspectionScrollTargetId(pathname: string): string | null {
  const protocolItemMatch = pathname.match(/\/protocolItem\/([^/]+)/);
  const checklistMatch = pathname.match(/\/checklist\/([^/]+)/);

  return protocolItemMatch?.[1] ?? checklistMatch?.[1] ?? null;
}

export function findInspectionForcedVisibleItemIndex(
  itemIds: readonly string[],
  pathname: string
): number | null {
  const targetId = resolveInspectionScrollTargetId(pathname);
  const exactIndex = findIndexById(itemIds, targetId);
  if (exactIndex !== null) {
    return exactIndex;
  }

  const pathSegments = pathname.split('/');
  const fallbackIndex = itemIds.findIndex((id) => pathSegments.includes(id));
  return fallbackIndex >= 0 ? fallbackIndex : null;
}

export function getInspectionVirtualRowTargetIds(
  row: InspectionVirtualRow
): string[] {
  if (row.type === 'checklistItem') {
    return [row.node.id];
  }
  return [row.node.id, row.node.data._id];
}

export function findInspectionForcedVisibleRowIndex(
  rows: readonly InspectionVirtualRow[],
  pathname: string
): number | null {
  const rowIds = rows.flatMap((row) => getInspectionVirtualRowTargetIds(row));
  const matchedIdIndex = findInspectionForcedVisibleItemIndex(
    rowIds,
    pathname
  );
  if (matchedIdIndex === null) {
    return null;
  }

  const matchedId = rowIds[matchedIdIndex];
  const rowIndex = rows.findIndex((row) =>
    getInspectionVirtualRowTargetIds(row).includes(matchedId)
  );
  return rowIndex >= 0 ? rowIndex : null;
}
